<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {

}
</script>

<style src="bulma" lang="sass"></style>
<style src="font-awesome/css/font-awesome.min.css"></style>



// WEBPACK FOOTER //
// App.vue?6c61a880